module.exports = __webpack_public_path__ + "static/media/blog.b9557e1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog.jpg
// module id = 1159
// module chunks = 0